export default __webpack_public_path__ + "static/media/758E5DF1-93EB-439B-8FFD-E2EF5A74328D_1_105_c.7723625a.jpeg";